module.exports = __webpack_public_path__ + "img/x1_2025_04_25@2x.f00ac049.png";